/*
  PYKAS ANALYTICS HOOKS (Master-Brief §11) — v2 nach QA-Audit
  Events: view_item, select_variant, view_selection_guide, select_use_case,
  add_to_cart, view_compatible_item, add_compatible_item, begin_checkout.
  Transport: window.dataLayer — kein Vendor-Code, keine PII.
  Consent (DSGVO): unbekannt = QUEUE (nie senden), true = flush, false = verwerfen.
  Ohne Consent-Plattform bleiben Events gequeued — der Shop braucht einen Cookie-Banner
  (z. B. Shopify Privacy Banner), damit die Hooks freigegeben werden. Siehe README.
*/
(function () {
  'use strict';

  var queue = [];
  var consent = null; // null = unbekannt

  function evaluateConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return null;
      if (typeof cp.analyticsProcessingAllowed === 'function') return Boolean(cp.analyticsProcessingAllowed());
      if (typeof cp.userCanBeTracked === 'function') return Boolean(cp.userCanBeTracked());
    } catch (e) { /* Privacy-API nicht bereit */ }
    return null;
  }

  function flush() {
    while (queue.length) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(queue.shift());
    }
  }

  function applyConsent(state) {
    if (state === true) { consent = true; flush(); }
    else if (state === false) { consent = false; queue.length = 0; }
    // null: Entscheidung offen — weiter queuen, nichts verwerfen
  }

  function track(name, payload) {
    var evt = Object.assign({ event: name }, payload || {});
    if (consent === false) return;
    if (consent === true) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(evt);
      return;
    }
    queue.push(evt);
    if (queue.length > 50) queue.shift();
  }

  document.addEventListener('visitorConsentCollected', function () {
    applyConsent(evaluateConsent());
  });

  // Privacy-API laedt asynchron: mehrfach nachpruefen statt Unbekannt als Zustimmung zu werten
  [500, 1500, 4000].forEach(function (ms) {
    window.setTimeout(function () { if (consent === null) applyConsent(evaluateConsent()); }, ms);
  });

  function initPdp() {
    var root = document.querySelector('[data-pykas-buybox]');
    if (!root) return;
    var base = {
      product_id: root.dataset.productId || null,
      product_format: root.dataset.productFormat || null,
      recipe_family: root.dataset.recipeFamily || null
    };

    track('view_item', Object.assign({}, base, {
      variant_id_if_selected: (root.querySelector('[data-pykas-variant-id]') || {}).value || null,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null
    }));

    document.addEventListener('pykas:variant', function (event) {
      var d = event.detail || {};
      if (d.initial) return; // Init-Sync der Buybox ist keine Nutzer-Auswahl
      track('select_variant', Object.assign({}, base, {
        variant_id: d.id, option_value: d.title, price: d.price, currency: d.currency
      }));
    });

    root.addEventListener('toggle', function (event) {
      var el = event.target;
      if (el.tagName === 'DETAILS' && el.open) {
        var summary = el.querySelector('summary');
        track('view_selection_guide', Object.assign({}, base, {
          guide_id: summary ? summary.textContent.trim().slice(0, 60) : 'accordion'
        }));
      }
    }, true);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.target.dataset.pykasSeen) return;
          entry.target.dataset.pykasSeen = '1';
          track('view_compatible_item', Object.assign({}, base, {
            related_variant_id: entry.target.dataset.variantId || null,
            relationship_role: entry.target.dataset.rolle || 'extra'
          }));
        });
      }, { threshold: 0.6 });
      document.querySelectorAll('[data-pykas-extra-add]').forEach(function (el) { io.observe(el); });
    }
  }

  function isCheckoutUrl(href) {
    try {
      var p = new URL(href, window.location.origin).pathname;
      return p === '/checkout' || p.indexOf('/checkouts/') === 0;
    } catch (e) { return false; }
  }

  function initGlobal() {
    document.addEventListener('pykas:atc-success', function (event) {
      var d = event.detail || {};
      var root = document.querySelector('[data-pykas-buybox]');
      var base = root ? { product_id: root.dataset.productId || null } : {};
      if (d.source === 'extra') {
        track('add_compatible_item', Object.assign({}, base, {
          related_variant_id: d.variantId, relationship_role: 'extra'
        }));
      } else {
        track('add_to_cart', Object.assign({}, base, {
          variant_id: d.variantId, quantity: d.quantity, price: d.price, currency: d.currency,
          source_section: d.source || 'buybox'
        }));
      }
    });

    document.addEventListener('click', function (event) {
      var useCase = event.target.closest('.pykas-category-tiles a, [data-pykas-usecase]');
      if (useCase) {
        track('select_use_case', {
          use_case_id: useCase.textContent.trim().slice(0, 60),
          destination: useCase.getAttribute('href')
        });
        return;
      }
      var btn = event.target.closest('button[name="checkout"]');
      if (btn) { track('begin_checkout', { source: 'cart' }); return; }
      var link = event.target.closest('a[href]');
      if (link && isCheckoutUrl(link.getAttribute('href'))) track('begin_checkout', { source: 'link' });
    }, true);
  }

  function init() {
    applyConsent(evaluateConsent());
    initPdp();
    initGlobal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
